module.exports = __webpack_public_path__ + "images/store_case_study/turtle-pic1_c305fbb68218e9ac820e0f5e77b522c1.png";